import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setJobData,
    create_send_message,
    get_job_messages,
    setTabIndex,
    setPrevStage,
    setNewStage,
    submit_job,
    clearJobData,
    clearJobDetail,
    get_job_detail,
    update_job,
    download_file,
    download_zip_file,
    get_job_list,
    setJobPage,
    sendProof,
    proof_log_table,
} from "../../../store/job/jobSlice";
import { get_company_process, get_user_company, setProcessTab, setProcessHasJobForm, get_company_users_list } from "../../../store/user/userSlice";

const mapStateToProps = (state) => {
    const { job_form, selected_process_tab, selected_company, user_company, company_process } = state.user;
    const { is_job_loading,
        job_data,
        job_messages,
        send_message_loading,
        tab_index,
        job_detail,
        prev_stage,
        new_stage,
        job_list,
        page,
        limit,
        total_count,
        sendProof,
        proof_log_data
    } = state.job;
    return {
        job_form: job_form,
        selected_process_tab: selected_process_tab,
        selected_company: selected_company,
        is_job_loading: is_job_loading,
        job_data: job_data,
        job_messages: job_messages,
        send_message_loading: send_message_loading,
        tab_index: tab_index,
        job_detail: job_detail,
        prev_stage: prev_stage,
        new_stage: new_stage,
        job_list: job_list,
        page: page,
        limit: limit,
        total_count: total_count,
        proof_log_data: proof_log_data,
        user_company: user_company,
        company_process: company_process,
        company_users_list: state.user.company_users_list,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setJobData,
            create_send_message,
            get_job_messages,
            setTabIndex,
            setPrevStage,
            setNewStage,
            submit_job,
            clearJobData,
            clearJobDetail,
            get_job_detail,
            update_job,
            download_file,
            download_zip_file,
            get_job_list,
            setJobPage,
            get_company_process,
            proof_log_table,
            get_user_company,
            setProcessTab,
            setProcessHasJobForm,
            get_company_users_list,
        },
        dispatch
    );


const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;